import React from "react";
//import PropTypes from 'prop-types';

import Entries from "./../Entries";
import { FormLayout } from "playground/cms/Form";
import OfferForm from "./OfferForm";
import { ListLayout } from "../../List";
import { ListSyncTask } from "playground/cms/views/SyncTasks";

export function Offers(props) {
    return (
        <>
            <Entries {...props}>
                <ListLayout>
                    <ListLayout.Header>
                        <ListLayout.Header.Addon>
                            <ListSyncTask {...props} />
                        </ListLayout.Header.Addon>
                    </ListLayout.Header>
                </ListLayout>
                <FormLayout>
                    <FormLayout.Content prepend={true}>
                        <FormLayout.Tab id={"offer"} label={"Oferta"}>
                            <OfferForm {...props} />
                        </FormLayout.Tab>
                    </FormLayout.Content>
                </FormLayout>
            </Entries>
        </>
    );
}

Offers.propTypes = {};

Offers.defaultProps = {};

export default Offers;
